export default "__VITE_ASSET__CdjDZmma__"